import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "src/environments/environment";
import {Tatime} from "../models/SearchService/tatime.model";

@Injectable({
    providedIn: "root"
})
export class TatimeHttpClientService {
    private readonly base = environment.backendBaseUrl;
    private readonly endpoint = "/api/tatime";
    private readonly fullPath = `${this.base}${this.endpoint}`;
    private readonly searchURL = `${this.fullPath}/search`;
    private readonly CCURL = `${this.fullPath}/start-cc`;
    // TODO: Should fix
    private readonly walletURL = `${this.fullPath}/payment/web`;
    private readonly commissionURL = `${this.fullPath}/commission`;

    constructor(private http: HttpClient) {
    }

    Search(serialNumber: string) {
        const params = new HttpParams().set("serialNumber", serialNumber);

        return this.http.get<Tatime>(this.searchURL, {
            params
        });
    }

    PayCC(invoice: any) {
        return this.http.post<any>(this.CCURL, invoice);
    }

    PayWallet(invoice: any) {
        return this.http.post<any>(this.walletURL, invoice);
    }

    GetCommission(amount: number) {
        return this.http.post<{ amount: number }>(this.commissionURL, {
            amount
        });
    }
}
